export const SMS_PRICING_DIALOG_TITLE_ID = 'sms-notification-pricing-title';

export const SMS_PRICING_BILLING_ITEMS = [
  {
    titleKey: 'settings:SMS_PRICING_CARRIER_COST_TITLE',
    bodyKey: 'settings:SMS_PRICING_CARRIER_COST_BODY',
  },
  {
    titleKey: 'settings:SMS_PRICING_ADMIN_FEE_TITLE',
    bodyKey: 'settings:SMS_PRICING_ADMIN_FEE_BODY',
  },
  {
    titleKey: 'settings:SMS_PRICING_INVOICE_TITLE',
    bodyKey: 'settings:SMS_PRICING_INVOICE_BODY',
  },
] as const;

export const SMS_PRICING_BILLABLE_UNIT_ROWS = [
  {
    sendingKey: 'settings:SMS_PRICING_ROW_STANDARD_SENDING',
    billedAsKey: 'settings:SMS_PRICING_ROW_STANDARD_BILLED_AS',
    meaningKey: 'settings:SMS_PRICING_ROW_STANDARD_MEANING',
    isBilled: true,
  },
  {
    sendingKey: 'settings:SMS_PRICING_ROW_SPECIAL_CHARACTERS_SENDING',
    billedAsKey: 'settings:SMS_PRICING_ROW_SPECIAL_CHARACTERS_BILLED_AS',
    meaningKey: 'settings:SMS_PRICING_ROW_SPECIAL_CHARACTERS_MEANING',
    isBilled: true,
  },
  {
    sendingKey: 'settings:SMS_PRICING_ROW_LONG_MESSAGE_SENDING',
    billedAsKey: 'settings:SMS_PRICING_ROW_LONG_MESSAGE_BILLED_AS',
    meaningKey: 'settings:SMS_PRICING_ROW_LONG_MESSAGE_MEANING',
    isBilled: true,
  },
  {
    sendingKey: 'settings:SMS_PRICING_ROW_CALL_OUT_SENDING',
    billedAsKey: 'settings:SMS_PRICING_ROW_CALL_OUT_BILLED_AS',
    meaningKey: 'settings:SMS_PRICING_ROW_CALL_OUT_MEANING',
    isBilled: true,
  },
  {
    sendingKey: 'settings:SMS_PRICING_ROW_INVALID_NUMBERS_SENDING',
    billedAsKey: 'settings:SMS_PRICING_ROW_INVALID_NUMBERS_BILLED_AS',
    meaningKey: 'settings:SMS_PRICING_ROW_INVALID_NUMBERS_MEANING',
    isBilled: false,
  },
] as const;
